module.exports = __webpack_public_path__ + "content/5a9681c876cc158bf5e71eaa13bc162e.svg";